import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-custom-checkboxdropdown',
  templateUrl: './custom-checkboxdropdown.component.html',
  styleUrls: ['./custom-checkboxdropdown.component.scss'],
})
export class CustomCheckboxdropdownComponent {
  @Input() items: string[] = [];
  @Input() selectedItems: string[] = [];
  @Input() label: string = '';
  @Input() placeholder: string = 'Select';
  @Input() autoClose: boolean = false;
  @Input() isFilterSubmit: boolean = false;

  @Output() selectionChange = new EventEmitter<string[]>();

  isDropdownOpen = false;
  allSelected = false;

  constructor(private eRef: ElementRef) {}

  ngOnChanges() {
    if (this.isFilterSubmit) {
      this.isDropdownOpen = false;
    }
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  isSelected(item: string): boolean {
    if (item === 'All') return this.allSelected;
    return this.selectedItems.includes(item);
  }

  onCheckboxChange(item: string, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    const realItems = this.items.filter((i) => i !== 'All');

    if (item === 'All') {
      this.selectedItems = checked ? [...realItems] : [];
      this.allSelected = checked;
      this.selectionChange.emit([...this.selectedItems]);
      return;
    }

    if (checked) {
      this.selectedItems = [...this.selectedItems, item];
    } else {
      this.selectedItems = this.selectedItems.filter((i) => i !== item);
    }

  
    this.allSelected = this.selectedItems.length === realItems.length;

    this.selectionChange.emit([...this.selectedItems]);
  }


  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (
      this.autoClose &&
      this.isDropdownOpen &&
      !this.eRef.nativeElement.contains(event.target)
    ) {
      this.isDropdownOpen = false;
    }
  }
}
